import dayjs from 'dayjs'
import 'dayjs/locale/pl'
import 'dayjs/locale/en'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.locale(document.documentElement.lang)

export default dayjs